export default __webpack_public_path__ + "static/media/help_darkGray1.38e8da85.svg";